import React from 'react';

const Divider = () => (
    <hr className="eds-divider__hr eds-bg-color--grey-200 eds-divider--horizontal" />
);

export default Divider;
